<template>
  <v-container width="80%">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">
          {{ title }}
          <v-chip
            small
            depressed
            :color="getColor()"
            style="border-radius: 5px"
            outlined
            v-if="filterData.txn_status"
          >
            {{ txnStatus }}
          </v-chip>
          Transactions
        </div>
        <div>
          <bread-crumb :bread-crumbs="['Hold Transactions']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <div class="">
        <v-card-text class="mb-3">
          <v-row>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="mt-2 ms-1"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter values."
              hide-details
              dense
              single-line
              clearable
              class="mt-2"
            ></v-text-field
          ></v-row>
        </v-card-text>

        <v-data-table
          dense
          :loading="loader"
          loading-text="Loading... Please wait"
          :headers="headers"
          :items="holdTxnlist"
          class=""
        >
          <template v-slot:item.actions="{ item }">
            <v-btn
              depressed
              outlined
              small
              color="green"
              class="text-capitalize"
              @click="openPopup(item)"
              >Release<v-icon x-small class="ms-2"
                >mdi-checkbox-marked-circle-outline</v-icon
              ></v-btn
            >
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip rounded small color="primary" block outlined>
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:item.transaction_id="{ item }">
            <a class="border-d" @click="viewTxn(item)">{{ item.transaction_id }}</a>
          </template>
          <template v-slot:item.bank_receipt="{ item }">
            <v-img
              v-if="item.bank_receipt"
              class="ml-1"
              max-height="40"
              max-width="50"
              :src="item.bank_receipt"
              @click="handleImageViewer(item.bank_receipt, '')"
            />
          </template>
        </v-data-table>
      </div>
      <v-dialog persistent v-model="showPopup" max-width="500px">
        <OverlayPageVue :showOverlay="loader" />
        <v-card>
          <v-toolbar class="ma-0 pa-0" color="secondary" dark flat dense>
            <span>Release Transaction</span>
            <!-- <v-spacer></v-spacer> -->
            <v-spacer></v-spacer>
            <v-icon small @click="closePopup">mdi-close</v-icon>
          </v-toolbar>
          <v-form>
            <!-- <v-divider class="ma-0 pa-0"></v-divider> -->
            <v-card-text class="mt-2">
              <v-form v-model="valid" ref="releaseForm">
                <v-row>
                  <v-col cols="12" sm="12" md="12"
                    ><label class="my-0 labelFontsize required"> Status </label>
                    <v-autocomplete
                      class="rounded"
                      dense
                      outlined
                      placeholder="Status"
                      :items="status_items"
                      :rules="validations.statusRules"
                      v-model="selectedStatus"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="12"
                    ><label class="my-0 labelFontsize required"> Release </label>
                    <v-autocomplete
                      class="rounded"
                      dense
                      outlined
                      placeholder="Release"
                      :items="release_items"
                      :rules="validations.releaseRules"
                      v-model="selectedReleaseItem"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    class="my-0"
                    v-if="selectedReleaseItem === 'Others'"
                    ><label class="my-0 labelFontsize required">Remarks</label>
                    <v-text-field
                      class="rounded"
                      dense
                      outlined
                      :rules="validations.remarksRules"
                      placeholder="Remarks"
                      v-model="remarks"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-form>

          <v-card-actions class="justify-end">
            <v-btn
              depressed
              outlined
              class="text-capitalize primary--text"
              small
              @click="updateTxnStatus()"
              >Submit</v-btn
            >
            <!-- <v-btn
                    depressed
                    color="error"
                    class="text-capitalize"
                    outlined
                    small
                    @click="updateTxnStatus('Cancel')"
                    >Reject</v-btn
                  >
                  <v-btn
                    depressed
                    color="warning"
                    class="text-capitalize"
                    outlined
                    small
                    @click="updateTxnStatus('Hold')"
                    >Hold</v-btn
                  >
                  <v-btn
                    depressed
                    color="primary"
                    class="text-capitalize"
                    small
                    @click="updateTxnStatus('Success')"
                    >Release</v-btn
                  > -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '350',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </v-container>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import imageViewer from "@/components/tools/imageViewer.vue";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "../../utils/OverlayPage.vue";
import AgentService from "@/services/agentService/AgentService";
export default {
  name: "Search Transaction",
  mixins: [alerts],
  data() {
    return {
      showPopup: false,
      imageViewerUrl: null,
      isImageViewer: false,
      showRemarksField: false,
      selectedReleaseItem: null,
      remarks: "",
      valid: false,
      selectedTxn: null,
      isToday: null,
      title: "",
      txnStatus: "",
      search: "",
      selectedStatus: "",
      filterData: {
        pin_number: "",
        beneficiary_name: "",
        txn_status: "06",
        txn_stage: "",
        from_date: null,
        to_date: null,
        skip: 0,
        limit: 2000000,
      },
      headers: [
        // { text: "ID", value: "id", sortable: false },
        { text: "PIN No", value: "transaction_id", sortable: false },
        // { text: "Deposit Type", value: "id", sortable: false },
        { text: "TXN date", value: "send_date", sortable: false },
        { text: "TXN status", value: "status", sortable: false },
        { text: "Payment mode", value: "mode_of_payment", sortable: false },
        { text: "Sender name", value: "sender_name", sortable: false },
        {
          text: "Payout country",
          value: "country",
          sortable: false,
        },
        {
          text: "Beneficiary name",
          value: "beneficiary_name",
          sortable: false,
        },
        {
          text: "Receiving agent",
          value: "receiving_partner",
          sortable: false,
        },

        {
          text: "Receiving amount",
          value: "receiving_amount",
          sortable: false,
        },
        { text: "Remarks", value: "remarks", sortable: false },
      ],
      holdTxnlist: [],
      release_items: [],
      status_items: ["Processing", "Paid", "Cancel", "Hold", "Success"],
      validations: {
        releaseRules: [(v) => !!v || "Required"],
        remarksRules: [(v) => !!v || "Required"],
        statusRules: [(v) => !!v || "Required"],
      },
      loader: false,
    };
  },
  components: {
    BreadCrumb,
    imageViewer,
    OverlayPageVue,
  },
  mounted() {
    this.filterData.txn_status = this.$route?.query?.txn_status;
    this.filterData.txn_stage = this.$route?.query?.txn_stage;
    this.isToday = this.$route?.query?.is_today;
    this.filterData.from_date = this.isToday
      ? new Date().toISOString().substr(0, 10)
      : null;
    this.filterData.to_date = this.isToday
      ? new Date().toISOString().substr(0, 10)
      : null;
    this.title = this.isToday ? "Today" : "All";
    if (this.$route?.query?.txn_status == 6) {
      this.txnStatus = "Paid";
    } else if (
      this.$route?.query?.txn_status == 2 &&
      this.$route?.query?.txn_stage == 2
    ) {
      this.txnStatus = "Hold";
    } else if (
      this.$route?.query?.txn_status == 2 &&
      this.$route?.query?.txn_stage == 4
    ) {
      this.txnStatus = "Hold";
    }

    console.log(this.isToday);
    this.getHoldTransactions(this.filterData);
    //   this.getReleaseRemarks();
  },
  watch: {},
  methods: {
    getColor() {
      if (this.$route?.query?.txn_status == 6) {
        return "green";
      } else if (
        this.$route?.query?.txn_status == 2 &&
        this.$route?.query?.txn_stage == 2
      ) {
        return "#820a75";
      } else if (
        this.$route?.query?.txn_status == 2 &&
        this.$route?.query?.txn_stage == 4
      ) {
        return "#195fc3";
      }
    },
    async downloadExcelsheet() {
      if (this.holdTxnlist) {
        this.exportToExcel(this.headers, this.holdTxnlist, "holdTxn_list");
      }
    },
    viewTxn(item) {
      this.$router.push({
        name: "Hold Details",
        query: { id: item.id, login_id: item.login_id, from: "hold" },
      });
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url, val) {
      if (val === "showImage") {
        this.isImageViewer = !this.isImageViewer;
        this.imageViewerUrl = url;
      } else {
        this.isImageViewer = !this.isImageViewer;
        this.imageViewerUrl = url;
      }
    },
    Imageview(file) {
      const imageurl = URL.createObjectURL(file);
      this.suspectFileUrl = imageurl;
    },

    async getHoldTransactions(data) {
      this.loader = true;
      console.log(this.filterData);
      try {
        const responseData = await AgentService.getHoldTxnSummary(data);
        this.loader = false;
        if (responseData && responseData.data.status_code === 200) {
          this.holdTxnlist = responseData.data.data.reverse();
        } else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("getdata", responseData.data.status_code);
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
      }
    },
    openPopup(item) {
      console.log(item);
      this.selectedTxn = item;
      this.selectedReleaseItem = null;
      this.remarks = item.remarks;
      this.showPopup = true;
    },
    closePopup() {
      // Close the popup
      this.showPopup = false;
      this.selectedReleaseItem = null;
      this.remarks = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
